// extracted by mini-css-extract-plugin
var _1 = "hRzNrLo9ZQh_m8cpKQXg";
var _2 = "oYQFbDD6EpTJ6E7U7Gc0";
export { _1 as "active", _2 as "activeBot" }
